// export const GMT_REGIONS = [
//   {
//     value: "-12",
//     label: "Baker Island, USA (Baker Island Time) (GMT -12:00)",
//   },
//   {
//     value: "-11",
//     label: "Pago Pago, American Samoa (Samoa Standard Time) (GMT -11:00)",
//   },
//   {
//     value: "-10",
//     label: "Honolulu, USA (Hawaii-Aleutian Standard Time) (GMT -10:00)",
//   },
//   {
//     value: "-9",
//     label:
//       "Anchorage, USA (Alaska Standard Time), Honolulu, USA (Hawaii-Aleutian Standard Time) (GMT -09:00)",
//   },
//   {
//     value: "-8",
//     label:
//       "Los Angeles, USA (Pacific Standard Time), San Francisco, USA (Pacific Standard Time), Vancouver, Canada (Pacific Standard Time) (GMT -08:00)",
//   },
//   {
//     value: "-7",
//     label:
//       "Denver, USA (Mountain Standard Time), Phoenix, USA (Mountain Standard Time), Calgary, Canada (Mountain Standard Time) (GMT -07:00)",
//   },
//   {
//     value: "-6",
//     label:
//       "Mexico City, Mexico (Central Standard Time), Chicago, USA (Central Standard Time), Guatemala City, Guatemala (Central Standard Time) (GMT -06:00)",
//   },
//   {
//     value: "-5",
//     label:
//       "New York, USA (Eastern Standard Time), Toronto, Canada (Eastern Standard Time), Bogota, Colombia (Colombia Time) (GMT -05:00)",
//   },
//   {
//     value: "-4",
//     label:
//       "Caracas, Venezuela (Venezuela Time), La Paz, Bolivia (Bolivia Time), Santiago, Chile (Chile Standard Time) (GMT -04:00)",
//   },
//   {
//     value: "-3",
//     label:
//       "Buenos Aires, Argentina (Argentina Time), Rio de Janeiro, Brazil (Brasilia Standard Time), Sao Paulo, Brazil (Brasilia Standard Time) (GMT -03:00)",
//   },
//   {
//     value: "-2",
//     label:
//       "South Georgia and the South Sandwich Islands (South Georgia Time) (GMT -02:00)",
//   },
//   {
//     value: "-1",
//     label:
//       "Azores, Portugal (Azores Standard Time), Cape Verde (Cape Verde Time) (GMT -01:00)",
//   },
//   {
//     value: "+0",
//     label:
//       "London, United Kingdom (Greenwich Mean Time), Dublin, Ireland (Greenwich Mean Time), Accra, Ghana (Greenwich Mean Time) (GMT 00:00)",
//   },
//   {
//     value: "+1",
//     label:
//       "Berlin, Germany (Central European Time), Paris, France (Central European Time), Rome, Italy (Central European Time), Amsterdam, Netherlands (Central European Time) (GMT +01:00)",
//   },
//   {
//     value: "+2",
//     label:
//       "Athens, Greece (Eastern European Time), Cairo, Egypt (Eastern European Time), Helsinki, Finland (Eastern European Time), Jerusalem, Israel (Israel Standard Time) (GMT +02:00)",
//   },
//   {
//     value: "+3",
//     label:
//       "Moscow, Russia (Moscow Standard Time), Dubai, UAE (Gulf Standard Time), Riyadh, Saudi Arabia (Arabian Standard Time) (GMT +03:00)",
//   },
//   {
//     value: "+4",
//     label:
//       "Baku, Azerbaijan (Azerbaijan Time), Tbilisi, Georgia (Georgia Standard Time), Yerevan, Armenia (Armenia Time) (GMT +04:00)",
//   },
//   {
//     value: "+5",
//     label:
//       "Islamabad, Pakistan (Pakistan Standard Time), Tashkent, Uzbekistan (Uzbekistan Time), Ekaterinburg, Russia (Yekaterinburg Time) (GMT +05:00)",
//   },
//   {
//     value: "+6",
//     label:
//       "Almaty, Kazakhstan (Alma-Ata Time), Astana, Kazakhstan (Kazakhstan Time), Dhaka, Bangladesh (Bangladesh Standard Time) (GMT +06:00)",
//   },
//   {
//     value: "+7",
//     label:
//       "Bangkok, Thailand (Indochina Time), Jakarta, Indonesia (Western Indonesian Time), Ho Chi Minh City, Vietnam (Indochina Time) (GMT +07:00)",
//   },
//   {
//     value: "+8",
//     label:
//       "Beijing, China (China Standard Time), Singapore, Singapore (Singapore Time), Kuala Lumpur, Malaysia (Malaysia Time), Perth, Australia (Australian Western Standard Time) (GMT +08:00)",
//   },
//   {
//     value: "+9",
//     label:
//       "Tokyo, Japan (Japan Standard Time), Seoul, South Korea (Korea Standard Time), Jakarta, Indonesia (Central Indonesian Time) (GMT +09:00)",
//   },
//   {
//     value: "+10",
//     label:
//       "Sydney, Australia (Australian Eastern Standard Time), Melbourne, Australia (Australian Eastern Standard Time), Brisbane, Australia (Australian Eastern Standard Time) (GMT +10:00)",
//   },
//   {
//     value: "+11",
//     label:
//       "Solomon Islands (Solomon Islands Time), Vanuatu (Vanuatu Time) (GMT +11:00)",
//   },
//   {
//     value: "+12",
//     label:
//       "Fiji (Fiji Standard Time), Auckland, New Zealand (New Zealand Standard Time), Wellington, New Zealand (New Zealand Standard Time) (GMT +12:00)",
//   },
// ];

// export const GMT_REGIONS = [
//   {
//     value: "-12",
//     label: "Baker Island, USA (Baker Island Time) (GMT -12:00)",
//   },
//   {
//     value: "-11",
//     label: "Pago Pago, American Samoa (Samoa Standard Time) (GMT -11:00)",
//   },
//   {
//     value: "-10",
//     label: "Honolulu, USA (Hawaii-Aleutian Standard Time) (GMT -10:00)",
//   },
//   {
//     value: "-9",
//     label: "Anchorage, USA (Alaska Standard Time) (GMT -09:00)",
//   },
//   {
//     value: "-8",
//     label: "Los Angeles, USA (Pacific Standard Time) (GMT -08:00)",
//   },
//   {
//     value: "-7",
//     label: "Denver, USA (Mountain Standard Time) (GMT -07:00)",
//   },
//   {
//     value: "-6",
//     label: "Mexico City, Mexico (Central Standard Time) (GMT -06:00)",
//   },
//   {
//     value: "-5",
//     label: "New York, USA (Eastern Standard Time) (GMT -05:00)",
//   },
//   {
//     value: "-4",
//     label: "Caracas, Venezuela (Venezuela Time) (GMT -04:00)",
//   },
//   {
//     value: "-3",
//     label: "Buenos Aires, Argentina (Argentina Time) (GMT -03:00)",
//   },
//   {
//     value: "-2",
//     label:
//       "South Georgia and the South Sandwich Islands (South Georgia Time) (GMT -02:00)",
//   },
//   {
//     value: "-1",
//     label: "Azores, Portugal (Azores Standard Time) (GMT -01:00)",
//   },
//   {
//     value: "+0",
//     label: "London, United Kingdom (Greenwich Mean Time) (GMT +00:00)",
//   },
//   {
//     value: "+1",
//     label: "Berlin, Germany (Central European Time) (GMT +01:00)",
//   },
//   {
//     value: "+2",
//     label: "Athens, Greece (Eastern European Time) (GMT +02:00)",
//   },
//   {
//     value: "+3",
//     label: "Moscow, Russia (Moscow Standard Time) (GMT +03:00)",
//   },
//   {
//     value: "+4",
//     label: "Baku, Azerbaijan (Azerbaijan Time) (GMT +04:00)",
//   },
//   {
//     value: "+5",
//     label: "Islamabad, Pakistan (Pakistan Standard Time) (GMT +05:00)",
//   },
//   {
//     value: "+6",
//     label: "Almaty, Kazakhstan (Alma-Ata Time) (GMT +06:00)",
//   },
//   {
//     value: "+7",
//     label: "Bangkok, Thailand (Indochina Time) (GMT +07:00)",
//   },
//   {
//     value: "+8",
//     label: "Beijing, China (China Standard Time) (GMT +08:00)",
//   },
//   {
//     value: "+9",
//     label: "Tokyo, Japan (Japan Standard Time) (GMT +09:00)",
//   },
//   {
//     value: "+10",
//     label: "Sydney, Australia (Australian Eastern Standard Time) (GMT +10:00)",
//   },
//   {
//     value: "+11",
//     label: "Solomon Islands (Solomon Islands Time) (GMT +11:00)",
//   },
//   {
//     value: "+12",
//     label: "Fiji (Fiji Standard Time) (GMT +12:00)",
//   },
// ];

export const GMT_REGIONS = [
  {
    value: "-12",
    label: "GMT -12:00",
  },
  {
    value: "-11",
    label: "GMT -11:00",
  },
  {
    value: "-10",
    label: "GMT -10:00",
  },
  {
    value: "-9",
    label: "GMT -09:00",
  },
  {
    value: "-8",
    label: "GMT -08:00",
  },
  {
    value: "-7",
    label: "GMT -07:00",
  },
  {
    value: "-6",
    label: "GMT -06:00",
  },
  {
    value: "-5",
    label: "GMT -05:00",
  },
  {
    value: "-4",
    label: "GMT -04:00",
  },
  {
    value: "-3",
    label: "GMT -03:00",
  },
  {
    value: "-2",
    label: "GMT -02:00",
  },
  {
    value: "-1",
    label: "GMT -01:00",
  },
  {
    value: "+0",
    label: "GMT 00:00",
  },
  {
    value: "+1",
    label: "GMT +01:00",
  },
  {
    value: "+2",
    label: "GMT +02:00",
  },
  {
    value: "+3",
    label: "GMT +03:00",
  },
  {
    value: "+4",
    label: "GMT +04:00",
  },
  {
    value: "+5",
    label: "GMT +05:00",
  },
  {
    value: "+6",
    label: "GMT +06:00",
  },
  {
    value: "+7",
    label: "GMT +07:00",
  },
  {
    value: "+8",
    label: "GMT +08:00",
  },
  {
    value: "+9",
    label: "GMT +09:00",
  },
  {
    value: "+10",
    label: "GMT +10:00",
  },
  {
    value: "+11",
    label: "GMT +11:00",
  },
  {
    value: "+12",
    label: "GMT +12:00",
  },
];
